export const CHART_DESK_STORAGE_KEYS = {
  CORE: "mt6_chart_desk_core",
} as const;
